import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentPt = () => {
    return (
        <HighlightedText
            text="RECLAME O SEU BÔNUS bónus de 325% + 400 GIROS GRÁTIS"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['SEU', '325%']}
            breakBeforeWords={['bónus de']}
            className={styles.text_content}
        />
    )
}
